// @ts-nocheck
import { StoreGridProps } from "@store/Themes/common/props/grid";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface UserSettupStyles {
    title?: TypographyPresentationProps;
}

export interface StoreUserSetupInfoGridProps extends StoreGridProps {}

export const userSettupGridProps: StoreUserSetupInfoGridProps = {
    container: {
        gap: 0,
        css: css`
            ${gridGapStyles([pxToRem(30)], ["0.5em"])}
            font-size: ${({ theme }) => theme.design.typography.size.small};
        `,
    },
    item: {
        width: [12, 4, 6, 4, 4],
        printWidth: 4,
        css: css`
            flex-direction: column;
        `,
    },
};
export const userSettupProps: UserSettupStyles = {
    title: {
        variant: "h4",
    },
};
